import React from 'react';
import {
  alpha, ButtonBase, Stack, Typography,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import focusRing from '../../theme/focus';

const PinguStartingPrompts = ({
  prompts,
  onSelect,
}: {
  prompts: string[];
  onSelect: (prompt: string) => void;
}) => (
  <Stack spacing={2} sx={{ px: 4, pb: 1 }}>
    <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
      Ask about cases, rules and entities. Pingwin sees only what you have access to.
    </Typography>
    {prompts.map((prompt) => (
      <ButtonBase
        key={prompt}
        onClick={() => onSelect(prompt)}
        sx={{
          justifyContent: 'flex-start',
          gap: 2,
          width: '100%',
          px: 3,
          py: 2,
          border: 1,
          borderColor: 'divider',
          borderRadius: 1.5,
          textAlign: 'left',
          color: 'text.primary',
          '&:hover': {
            backgroundColor: (theme) => alpha(theme.palette.emphasisText.main, 0.08),
          },
          '&:focus-visible': { boxShadow: focusRing },
        }}
      >
        <ArrowForwardIcon fontSize="small" sx={{ color: 'text.secondary' }} />
        <Typography variant="body1">{prompt}</Typography>
      </ButtonBase>
    ))}
  </Stack>
);

export default PinguStartingPrompts;
